<template>
  <div class="address-content">
    <div class="address-form">
      <h2>请填写地址信息</h2>
      <div class="form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名：" prop="deliver_name">
            <el-input v-model="ruleForm.deliver_name"></el-input>
          </el-form-item>

          <el-form-item label="* 所在地区：">
            <el-col class="col">
              <el-form-item prop="deliver_province">
                <el-select
                  class="select-style"
                  v-model="ruleForm.deliver_province"
                  placeholder="选择省"
                  @change="handleProvinceValue"
                >
                  <el-option
                    v-for="item in cities"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="deliver_city">
                <el-select
                  class="select-style"
                  v-model="ruleForm.deliver_city"
                  placeholder="选择市"
                  @change="handleCityValue"
                >
                  <el-option
                    v-for="item in city"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="deliver_district">
                <el-select
                  class="select-style"
                  v-model="ruleForm.deliver_district"
                  placeholder="选择区"
                >
                  <el-option
                    v-for="item in area"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="详细地址：" prop="deliver_address">
            <el-input v-model="ruleForm.deliver_address"></el-input>
          </el-form-item>

          <el-form-item label="联系电话：" prop="deliver_phone">
            <el-input v-model="ruleForm.deliver_phone"></el-input>
          </el-form-item>
          <!-- <el-form-item label="邮政编码：" prop="post_code">
            <el-input v-model="ruleForm.post_code"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item> -->

          <el-form-item>
            <p class="info-txt">*为必填信息</p>
            <el-button
              class="submit-btn"
              type="primary"
              @click="submitForm('ruleForm')"
              >{{
                dialogData.prize.address.deliver_name ? '更新' : '提交'
              }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <button @click="handleCancel" class="x"></button>
  </div>
</template>
<script>
import http from '@/utils/http'
import { MEMES2020 } from '../../api/index.js'
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../../store/mutation-types'
import { Form, FormItem, Input, Button, Select, Option, Col } from 'element-ui'
import rules from '@/utils/prize_validator'
import cities from '@/mock/cities'

export default {
  name: 'PrizeAddRess',
  components: {
    elForm: Form,
    elFormItem: FormItem,
    elInput: Input,
    elButton: Button,
    elSelect: Select,
    elOption: Option,
    elCol: Col,
  },
  props: {
    dialogData: {
      type: Object,
      default: function() {
        return {}
      },
    },
  },
  data() {
    return {
      cities: cities,
      ruleForm: {
        id: 0,
        deliver_name: '',
        deliver_phone: '',
        deliver_province: '',
        deliver_city: '',
        deliver_district: '',
        deliver_address: '',
        // post_code: '',
        // email: '',
        // type: '',
        // related_id: '',
      },
      province: '',
      city: '',
      area: '',
      rules: rules,
    }
  },
  computed: {
    userPrize() {
      return this.$store.state.user_prize
    },
  },
  mounted() {
    this.addressInfo()
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    addressInfo() {
      let prize = this.dialogData.prize
      if (prize.address) {
        this.ruleForm = {
          id: prize.id,
          deliver_name: prize.address.deliver_name,
          deliver_province: prize.address.deliver_province,
          deliver_city: prize.address.deliver_city,
          deliver_district: prize.address.deliver_district,
          deliver_address: prize.address.deliver_address,
          deliver_phone: prize.address.deliver_phone,
        }
      } else {
        this.ruleForm.id = prize.id
      }
    },
    handleProvinceValue() {
      for (let i = 0; i < this.cities.length; i++) {
        if (this.ruleForm.deliver_province == this.cities[i].value) {
          this.city = this.cities[i].children
          this.ruleForm.deliver_city = ''
          this.area = this.cities[i].children[0].children
          this.ruleForm.deliver_district = ''
          return
        }
      }
    },
    handleCityValue() {
      for (let i = 0; i < this.city.length; i++) {
        if (this.city[i].value == this.ruleForm.deliver_city) {
          this.area = this.city[i].children
          this.ruleForm.deliver_district = ''
          return
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.task = 'update_contact'
          http.post(MEMES2020, this.ruleForm).then(data => {
            if (data.status == 'success') {
              let user_prize = this.userPrize

              user_prize.map(item => {
                if (item.id == this.ruleForm.id) {
                  if (item.address) {
                    item.address.deliver_name = this.ruleForm.deliver_name
                    item.address.deliver_province = this.ruleForm.deliver_province
                    item.address.deliver_city = this.ruleForm.deliver_city
                    item.address.deliver_district = this.ruleForm.deliver_district
                    item.address.deliver_address = this.ruleForm.deliver_address
                    item.address.deliver_phone = this.ruleForm.deliver_phone
                  } else {
                    item.address = {}
                    item.address.deliver_name = this.ruleForm.deliver_name
                    item.address.deliver_province = this.ruleForm.deliver_province
                    item.address.deliver_city = this.ruleForm.deliver_city
                    item.address.deliver_district = this.ruleForm.deliver_district
                    item.address.deliver_address = this.ruleForm.deliver_address
                    item.address.deliver_phone = this.ruleForm.deliver_phone
                  }

                  return item
                }
              })

              this.$store.state.user_prize = user_prize
              this.handleCancel()

              setTimeout(() => {
                this.$store.commit(DIALOG_OPTION, {
                  type: 'MESSAGE',
                  dialogTableVisible: true,
                  data: {
                    content: data.result,
                  },
                })
              }, 430)
            } else {
              setTimeout(() => {
                this.$store.commit(DIALOG_OPTION, {
                  type: 'MESSAGE',
                  dialogTableVisible: true,
                  data: {
                    content: data.error,
                  },
                })
              }, 430)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCancel() {
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/base.scss';
.address-content {
  width: 606px;
  height: 552px;
  margin: 0 auto;
  padding: 105px 78px;
  background-image: url('https://img.dota2.com.cn/file/f8/db/f8dbc8352ca4263dfecb1b00795e3a3e1596597636.png');
  position: relative;
  .info-txt {
    text-align: center;
    font-size: 14px;
    color: #a5a7bf;
    position: relative;
    left: 140%;
    margin-bottom: 6px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
    margin-bottom: 36px;
    color: #c3f1f6;
    text-align: center;
  }
  .school-input {
    /deep/ .el-input__inner {
      cursor: default;
    }
  }
  .submit-btn {
    position: relative;
    left: 144%;
    width: 120px;
    height: 42px;
    border: none;
    background-color: #fa9a28;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #fff;
  }
  .address-form {
    .chsi-url {
      position: absolute;
      left: -175px;
      bottom: -20px;
      opacity: 0.28;
      font-size: 14px;
    }
    /deep/ .el-select .el-input .el-select__caret {
      transform: rotateZ(0deg);
      margin-right: 3px;
    }
    /deep/ .el-select .el-input .el-select__caret.is-reverse {
      transform: rotateZ(0deg);
    }
    /deep/ .el-icon-arrow-up:before {
      content: '';
      position: absolute;
      top: 50%;
      margin-top: -5.5px;
      width: 13px;
      height: 9px;
      background-image: url(https://img.dota2.com.cn/file/40/fe/40fed8ace8e64e9b7068727b4f8cbb821591776875.png);
      background-size: 100% 100%;
    }
    /deep/ .el-form {
      .el-form-item__label,
      .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:before {
        color: #52c2d6;
        font-size: 16px;
        width: 116px;
        line-height: 36px;
      }
      .el-form-item {
        margin-bottom: 18px;
      }
      .el-form-item.is-error .el-input__inner,
      .el-form-item.is-error .el-input__inner:focus,
      .el-form-item.is-error .el-textarea__inner,
      .el-form-item.is-error .el-textarea__inner:focus {
        border-color: #f56c6c;
      }
      .el-upload--picture-card:hover,
      .el-upload:focus {
        border-color: transparent;
        color: #bdbdbd;
      }
      .el-form-item__content {
        float: left;
        line-height: initial;
        margin-left: -6px;
      }
      .el-form-item__error {
        left: 0;
        font-size: 14px;
      }
      .el-input__inner {
        width: 324px;
        height: 36px;
        background-color: #1c272b;
        border-radius: 0;
        color: #bdbdbd;
        padding: 0 6px;
        font-size: 16px;
        border-color: transparent;
        border-radius: 6px;
      }
      .avatar-uploader {
        height: 35px;
        float: left;
      }
      .upload-input {
        width: 243px;
        height: 35px;
        line-height: 35px;
        background-color: #7e8dff;
        float: left;
        text-align: left;
        overflow: hidden;
        margin-top: 3px;
        input {
          width: 243px;
        }
      }
      .upload-btn {
        width: 60px;
        height: 35px;
        font-size: 15px;
        background-color: transparent;
        border: solid 1px #7aa2ff;
        padding: 0;
        float: left;
        border-radius: 0;
        color: #fff;
        margin-left: 6px;
        margin-top: 3px;
      }
      .add-btn {
        margin-left: 0;
      }
      .fileGroup {
        overflow: hidden;
      }
      .col {
        .el-form-item__error {
          left: 0;
        }
        .el-form-item {
          float: left;
          margin-left: 6px;
          margin-bottom: 0;
          &:first-child {
            margin-left: 0;
          }
        }
        .el-form-item__content {
          padding-left: 0;
          margin-left: 0;
        }
        .el-select {
          width: 104px;
          input {
            width: 100%;
            padding: 0 6px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.x {
  position: absolute;
  right: 0px;
  top: 62px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-image: url('../../assets/close.png');
}
</style>
